import styled from "styled-components";

const CardContainer = styled.div`
    border: 1px solid lightgray;
    border-radius: 8px;
    /* padding: 8px; */
    display: flex;
    flex-direction: column;
    background: #fff;
    max-width: 250px;
    min-width: 250px;
    cursor: pointer;

    img {
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
    }
`;

const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 8px;
    padding-bottom: 12px;
    gap: 8px;
`;

export const Styles = {
    CardContainer,
    CardContent
}